import { render, staticRenderFns } from "./RecentlyHotAreaList.vue?vue&type=template&id=2ce8a6dc&"
import script from "./RecentlyHotAreaList.vue?vue&type=script&lang=js&"
export * from "./RecentlyHotAreaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports